import { FetchArgs } from "@reduxjs/toolkit/query";
import api from "../api";
import {
  GetFileSystemRequest,
  FileSystemResponse,
  DownloadFileRequest,
  DownloadFileResponse,
  DownloadArchiveRequest,
  DownloadArchiveResponse,
} from "../../types/interfaces";

export const filesStorageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getFileSystem: builder.query<FileSystemResponse, GetFileSystemRequest>({
      query: ({ prefix, continuation_token, search, limit, folder_type }) => {
        return {
          url: `/web/folders/`,
          params: {
            prefix: prefix,
            search: search || undefined,
            continuation_token: continuation_token || undefined,
            limit: limit || 100,
            folder_type: folder_type && folder_type !== "all" ? folder_type : undefined,
          },
        };
      },
      providesTags: ["FileSystem"],
    }),

    downloadFile: builder.query<DownloadFileResponse, DownloadFileRequest>({
      query: ({ source }): FetchArgs => ({
        url: `/web/files/download_url/`,
        method: "GET",
        params: {
          fname: source,
        },
        responseHandler: (response: Response) => response.json(),
      }),
    }),

    downloadArchive: builder.query<DownloadArchiveResponse, DownloadArchiveRequest>({
      query: ({ source }): FetchArgs => ({
        url: `/web/files/download/`,
        method: "GET",
        params: {
          source: source,
        },
        responseHandler: async (response: Response) => {
          // Check if response is a zip file (local development case)
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/zip')) {
            return await response.blob();
          }

          // Try to parse as JSON - could be direct URL response or error
          try {
            const jsonResponse = await response.json();
            // Check if it's the direct URL response format
            if (jsonResponse.download_url && jsonResponse.filename) {
              return jsonResponse;
            } else {
              // Error response
              return jsonResponse;
            }
          } catch (parseError) {
            // If we can't parse JSON, treat as error
            return { error: 'Invalid response format' };
          }
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetFileSystemQuery,
  useLazyGetFileSystemQuery,
  useLazyDownloadFileQuery,
  useLazyDownloadArchiveQuery,
} = filesStorageApi;
